<template>
  <div class="panels-container">
    <center>
      <table height="100%" width="750">
        <tr>
          <td
            v-for="(sponsor, index) in displayedSponsors"
            :key="sponsor.number"
            style="padding: 0px 5px 0px 5px"
            class="td-panels"
          >
            <v-card
              class="panel-cards"
              @click="pushData(sponsor.method, sponsor.name, sponsor.id, sponsor.icon, sponsor.panelID, sponsor.number)"
            >
              <v-card-text
                v-if="!sponsorImage"
                class="primary panel-number white--text"
              >{{index + 1}}</v-card-text>
              <v-img
                v-if="sponsorImage"
                v-bind:src="createURL(sponsor.icon.handle)"
                :alt="sponsor.icon.handle"
                class="sponsor-image"
              >
                <v-card-text class="primary panel-number white--text">{{index + 1}}</v-card-text>
                <!--<v-card-text class="primary panel-name white--text">{{sponsor.name}}</v-card-text>-->
              </v-img>
              <v-icon v-if="!sponsorImage" medium center class="panel-icon">{{sponsor.icon}}</v-icon>
              <v-card-text class="primary panel-name down white--text">{{sponsor.name}}</v-card-text>
            </v-card>
          </td>
        </tr>
      </table>
    </center>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { setTimeout } from "timers";
import { filestack } from '@/components/mixins/filestack.js'
export default {
  mixins: [filestack],
  data() {
    return {
      sponsorImage: true,
      panelNumber: 0,
      shortcuts: {
        Digit1: "pressKey",
        Digit2: "pressKey",
        Digit3: "pressKey",
        Digit4: "pressKey",
        Digit5: "pressKey",
        Digit6: "pressKey",
        Digit7: "pressKey",
        Digit8: "pressKey",
        Digit9: "pressKey",
        Digit0: "pressKey",
        ArrowUp: "panelUp",
        ArrowDown: "panelDown"
      },
      displayedSponsors: [], // 1st panel
      type: [], // 2nd panel
      location: [], // 3rd panel
      clarity: [], // 4th panel
      game: [], // the current game
      sponsorList: [] //sponsors per game
    };
  },
  computed: {
    ...mapState({
      actionsBtnsPanels: state => state.actionsBtnsPanels.btnPressed,
      clipResult: state => state.clip.result,
      portal: state => state.portal,
      Sponsors: state => state.Admin.Sponsors,
      Types: state => state.panel.Type,
      Locations: state => state.panel.Location,
      Clarity: state => state.panel.Clarity,
      gameID: state => state.game.gameID,
      GameByID: state => state.Admin.GameByID,
      integration: state => state.integration
    })
  },
  watch: {
    actionsBtnsPanels: {
      handler(val) {
        // console.log("Action button panels: " + JSON.stringify(val, null, 2));
        this[val]();
      },
      deep: true
    },
    portal: {
      handler: function() {
        this.readDocuments();
      },
      deep: true
    },
    InitializeSponsors: {
      handler: function() {
        this.displayedSponsors = [];
        this.initializeSponsors();
      },
      immediate: true,
      deep: true
    },
    SponsorsResult: {
      handler: function() {
        this.readDocuments();
      },
      immediate: true,
      deep: true
    },
    Types: {
      handler: function() {
        this.type = this.Types;
      },
      deep: true
    },
    TypeResult: {
      handler: function() {
        this.readTypes();
      }
    },
    Locations: {
      handler: function() {
        this.location = this.Locations;
      },
      deep: true
    },
    LocationResult: {
      handler: function() {
        this.readLocation();
      },
      deep: true
    },
    Clarity: {
      handler: function() {
        this.clarity = this.Clarity;
      },
      deep: true
    },
    ClarityResult: {
      handler: function() {
        this.readClarity();
      },
      deep: true
    },
    GameByID: {
      handler: function() {
        this.game = this.GameByID;
        this.initializeSponsors();
      },
      immediate: true,
      deep: true
    },
    GameResultByID: {
      handler: function() {
        this.readGame();
      },
      deep: true
    }
  },
  methods: {
    panelUp() {
      this.panelNumber--;
      switch (this.panelNumber) {
        case 0:
          this.sponsorImage = true;
          this.displayedSponsors = this.sponsorList.sort(function(a, b) {
            return a.number - b.number;
          });
          this.$store.commit("clip/setValue", ["panelName", "Clients"]);
          break;
        case 1:
          this.sponsorImage = false;
          // console.log("spon image: " + this.sponsorImage);
          this.displayedSponsors = this.type.sort(function(a, b) {
            return a.number - b.number;
          });
          this.$store.commit("clip/setValue", ["panelName", "Type"]);
          break;
        case 2:
          this.sponsorImage = false;

          this.displayedSponsors = this.location.sort(function(a, b) {
            return a.number - b.number;
          });
          this.$store.commit("clip/setValue", ["panelName", "Location"]);
          break;
        case 3:
          this.sponsorImage = false;

          this.displayedSponsors = this.clarity.sort(function(a, b) {
            return a.number - b.number;
          });
          this.$store.commit("clip/setValue", ["panelName", "Clarity"]);
          break;
        case -1:
          this.panelNumber++;
          break;
      }
    },
    panelDown() {
      this.panelNumber++;
      switch (this.panelNumber) {
        case 0:
          this.sponsorImage = true;

          this.displayedSponsors = this.sponsorList.sort(function(a, b) {
            return a.number - b.number;
          });
          this.$store.commit("clip/setValue", ["panelName", "Clients"]);
          break;
        case 1:
          this.sponsorImage = false;

          this.displayedSponsors = this.type.sort(function(a, b) {
            return a.number - b.number;
          });
          this.$store.commit("clip/setValue", ["panelName", "Type"]);
          break;
        case 2:
          this.sponsorImage = false;

          this.displayedSponsors = this.location.sort(function(a, b) {
            return a.number - b.number;
          });
          this.$store.commit("clip/setValue", ["panelName", "Location"]);
          break;
        case 3:
          this.sponsorImage = false;

          this.displayedSponsors = this.clarity.sort(function(a, b) {
            return a.number - b.number;
          });
          this.$store.commit("clip/setValue", ["panelName", "Clarity"]);
          break;
        case 4:
          this.panelNumber--;
          break;
      }
    },
    pushData(action, name, sponsorID, icon, panelID, number) {
      this.$store.commit("actionsBtnsPanels/setButtonEmpty");
      this.$store.commit("actionsBtnsPanels/setButtonPressed", action);
      this.$store.dispatch("clip/sendClipData", [
        name,
        sponsorID,
        icon,
        panelID,
        number,
        "clip/setClipSendData"
      ]);
      // console.log("action: " + action);
    },
    pressKey() {
      var spon = this.displayedSponsors;
      var i = 0;
      var flag = 0;
      // console.log("length: " + spon.length);
      while (i < spon.length && flag == 0) {
        //console.log("here " + Object.keys(this.shortcuts)[i] + event.code);
        if (Object.keys(this.shortcuts)[i] == event.code) {
          this.pushData(
            spon[i].method,
            spon[i].name,
            spon[i].id,
            spon[i].icon,
            spon[i].panelID,
            spon[i].number
          );
          flag = 1;
        }
        i++;
      }
    },
    addClipData() {
      // console.log("Result: " + JSON.stringify(this.clipResult, null, 2));
      var name = this.clipResult[0];
      var sponsorID = this.clipResult[1];
      var icon = this.clipResult[2];
      var panelID = this.clipResult[3];
      var number = this.clipResult[4];
      switch (panelID) {
        case "1":
          this.$store.commit("clip/setActiveValue", ["sponsor", name]);
          this.$store.commit("clip/setActiveValue", ["sponsorID", sponsorID]);
          // console.log("name: " + name);
          this.$store.commit("clip/setValue", ["sponsorIcon", icon]);
          this.$store.commit("clip/setValue", ["panelID", panelID]);
          break;
        case "2":
          this.$store.commit("clip/setActiveValue", ["type", name]);
          this.$store.commit("clip/setValue", ["typeIcon", icon]);
          this.$store.commit("clip/setValue", ["panelID", panelID]);
          break;
        case "3":
          this.$store.commit("clip/setActiveValue", ["location", name]);
          this.$store.commit("clip/setValue", ["locationIcon", icon]);
          this.$store.commit("clip/setValue", ["panelID", panelID]);
          break;
        case "4":
          this.$store.commit("clip/setActiveValue", ["clarity", name]);
          this.$store.commit("clip/setActiveValue", ["clarityNumber", number]);
          this.$store.commit("clip/setValue", ["clarityIcon", icon]);
          this.$store.commit("clip/setValue", ["panelID", panelID]);
          break;
      }
    },
    //get sponsors from db
    readDocuments() {
      this.$store.dispatch("Admin/readSponsorPanel", [
        "sponsors",
        this.portal.active.id,
        "Admin/setSponsors"
      ]);
    },
    //show specific sponsors for game
    initializeSponsors() {
      //console.log("doc length: " + this.Sponsors.length);
      //console.log("GAME: " + JSON.stringify(this.GameByID, null, 2));
      this.sponsorList = [];
      this.displayedSponsors = [];

      for (var i = 0; i < this.Sponsors.length; i++) {
        for (var j = 0; j < this.GameByID.sponsorID.length; j++) {
          if (this.GameByID.sponsorID[j] === this.Sponsors[i].id) {
            this.$store.dispatch("Admin/readDocumentByID", [
              "sponsors",
              this.GameByID.sponsorID[j],
              "Admin/setDocByID"
            ]);
            this.sponsorList.push(this.Sponsors[i]);
          }
        }
      }
      this.displayedSponsors = this.sponsorList;
      //console.log("SPONSOR LIST: " + JSON.stringify(this.sponsorList, null, 2));
    },
    //get types from db
    readTypes() {
      this.$store.dispatch("panel/readType", [
        "types",
        this.portal.active.id,
        "panel/setType"
      ]);
    },
    //get locations from db
    readLocation() {
      this.$store.dispatch("panel/readLocation", [
        "location",
        this.portal.active.id,
        "panel/setLocation"
      ]);
    },
    //get clarity from db
    readClarity() {
      this.$store.dispatch("panel/readClarity", [
        "clarity",
        this.portal.active.id,
        "panel/setClarity"
      ]);
    },
    //return the current game
    readGame() {
      // console.log("GAME ID: " + this.gameID);
      this.$store.dispatch("Admin/readGameByID", [
        "games",
        this.gameID,
        "Admin/setGameByID"
      ]);
    }
  },
  mounted() {
    this.readGame();
    this.readDocuments();
    this.readTypes();
    this.readLocation();
    this.readClarity();
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);

    var checkEventCode = this;
    document.addEventListener("keydown", function(event) {
      //console.log(event.code);
      if (checkEventCode.shortcuts[event.code] !== undefined) {
        checkEventCode[checkEventCode.shortcuts[event.code]]();
      } else {
        // // console.log("Ignored");
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onkey);
  }
};
</script>

<style>
.panels-container {
  margin: 0 !important;
  padding-top: 5px !important;
  padding-bottom: 0px !important;
  max-width: 100% !important;
}

.panels {
  flex-basis: 7.6% !important;
}

.panel-number {
  text-align: center !important;
  padding: 0 !important;
  width: 30% !important;
}

.panel-cards {
  height: 72px !important;
  width: 72px !important;
}

.panel-icon {
  width: 100% !important;
  text-align: center !important;
}

.panel-name {
  padding: 0 !important;
  text-align: center;
  font-size: 10px;
}

.panel-name-letters {
  padding: 0 !important;
  text-align: center;
  font-size: 12px;
}

.down{
  position: absolute;
  bottom: 0 !important;
}

@media only screen and (max-width: 1210px) {
  .panel-cards {
    height: 65px !important;
    width: 65px !important;
    max-width: 65px !important;
  }
  .sponsor-image{
     height: 60px !important;
    width: 65px !important;
  }
}
</style>